import React from 'react';
import { useLogin } from '../hooks/useLogin';

const TermsAndConditions = () => {
	const { termsAndConditions } = useLogin();

	return (
		<div className="vtex-login-2-x-termsAndConditions termsAndConditions t-mini c-muted-2 tc">{termsAndConditions}</div>
	);
};

export default TermsAndConditions;
